import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
`;

export const StyledStepImageWrapper = styled.div`
  & .step-image {
    border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Large)};
  }
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.Small)};
`;

export const StyledTitleNumber = styled.div`
  aspect-ratio: 1;
  width: ${({ theme }) => utils.rem(theme.Sizes.X6Large)};
  border: ${({ theme }) => utils.rem(theme.Border.Size.Small)} solid
    ${({ theme }) => theme.Color.Neutrals.Border};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium)};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
